// src/pages/TermsPage.tsx
import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-center">Terms of Service</h1>
        
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-8">
          <p className="mb-4">Last updated: January 18, 2024</p>
          
          <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
          <p className="mb-6">
            By accessing or using the Word Game application, you agree to be bound by these Terms of Service.
          </p>

          <h2 className="text-2xl font-semibold mb-4">2. User Conduct</h2>
          <p className="mb-4">You agree not to:</p>
          <ul className="list-disc pl-6 space-y-2 mb-6">
            <li>Use the service for any illegal purpose</li>
            <li>Attempt to gain unauthorized access to the service</li>
            <li>Interfere with or disrupt the service or servers</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">3. Intellectual Property</h2>
          <p className="mb-6">
            All content included in the service, such as text, graphics, logos, and software, is the property of Word Game or its content suppliers.
          </p>

          <h2 className="text-2xl font-semibold mb-4">4. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. Your continued use of the service constitutes acceptance of those changes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;